import OutboundSMS from '../pages/system/OutboundSMS'
import Config2FA from '../pages/userPages/myAccount/Config2FA'
import MyAccount from '../pages/userPages/myAccount/MyAccount'
import AddNewTask from '../pages/userPages/tasks/AddNewTask'
import MyTasks from '../pages/userPages/tasks/MyTasks'
import Availability from '../pages/availability/Availability'
import MyAudits from '../pages/patientRecords/audits/MyAudits'
import Sitemap from '../pages/userPages/Sitemap'
import NotificationsPage from '../pages/userPages/notifications/NotificationsPage'

export default [
  { path: '/tasks/new', element: <AddNewTask />, title: 'New Task' },
  {
    path: '/my-tasks',
    element: <MyTasks />,
    title: 'My Tasks'
  },
  { path: '/my-audits', element: <MyAudits />, title: 'My Audits' },
  { path: '/sms', element: <OutboundSMS /> },
  { path: '/my-account', element: <MyAccount />, title: 'My Account' },
  { path: '/my-account/2fa', element: <Config2FA /> },
  { path: '/my-availability', element: <Availability />, title: 'My Availability' },
  { path: '/sitemap', element: <Sitemap />, title: 'Sitemap' },
  { path: '/notifications', element: <NotificationsPage />, title: 'Notifications' },
]
